<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text
          }}</v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- Listado de usuarios y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="esSuperadministrador ? cabUsuarioSA : cabUsuario" :items="usuarios"
          :items-per-page="15" class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">USUARIOS</v-toolbar-title>
              <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
              <!-- Impresion usuario -->
              <v-btn text fab x-small color="accent" @click="crearPDF()" class="mr-1">
                <v-icon>description</v-icon>
              </v-btn>
              <!-- Fin Impresion usuario -->
              <v-spacer />
              <!-- Formulario busqueda de usuario -->
              <v-text-field v-if="esSuperadministrador" class="text-xs-center" v-model.trim="buscar"
                append-icon="search" dense label="Búsqueda" @keyup="listar()" single-line hide-details></v-text-field>
              <v-spacer />
              <v-checkbox color="internal" v-model="uinactivo" label="Inactivos" @click="listar()" dense
                hide-details></v-checkbox>
              <!-- Fin Formulario busqueda de usuario -->
              <v-spacer />
              <!-- Modal crear y modificar usuario -->
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-2" fab x-small dark color="primary" v-on="on"
                    v-if="esSuperadministrador || esAdministrador">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar dark dense class="primary">
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="4" sm="2">
                          <v-select :items="avatares" v-model="avatar" dense hide-details>
                            <template v-slot:selection="{ item, index }">
                              <v-avatar size="26px">
                                <img :src="item.image" />
                              </v-avatar>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-avatar size="30px">
                                <img :src="item.image" />
                              </v-avatar>
                              <!-- {{ item.value }} -->
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="4" sm="5">
                          <v-text-field dense v-model.trim="nombres" label="Nombres"
                            :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 30) || 'Nombre debe tener entre 3 a 30 caracteres', Rules.unespacio]"
                            maxlength="30" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="5">
                          <v-text-field dense v-model.trim="apellidos" label="Apellidos"
                            :rules="[v => !!v || 'Apellido requerido', v => (!!v && v.length >= 3 && v.length <= 40) || 'Apellido debe tener entre 3 a 40 caracteres', Rules.unespacio]"
                            maxlength="40" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="num_documento" label="Numero Documento"
                            :rules="[v => !!v || 'Numero Documento requerido', v => (!!v && v.length == 8) || 'El numero debe tener 8 caracteres']"
                            maxlength="8" prepend-inner-icon="featured_play_list" v-mask-number
                            hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="nickname" label="Usuario"
                            :rules="[v => !!v || 'Usuario requerido', v => (!!v && v.length >= 4 && v.length <= 30) || 'Usuario debe tener entre 4 a 30 caracteres', Rules.sinespacio]"
                            maxlength="30" prepend-inner-icon="account_circle" v-lowercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select dense v-model="idrol" :items="roles" label="Rol"
                            :rules="[v => !!v || 'El rol es requerido']" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select dense v-model="idempresa" :items="empresas" label="Empresa"
                            :rules="[v => !!v || 'La empresa es requerido']" :disabled="!esSuperadministrador"
                            hide-details></v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="telefono" label="Telefono"
                            :rules="[v => !!v || 'Telefono requerido', Rules.unespacio]" maxlength="20"
                            prepend-inner-icon="phone" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="direccion" label="Direccion"
                            :rules="[v => !!v || 'Dirección requerido', v => (!!v && v.length >= 5 && v.length <= 60) || 'La dirección no debe tener entre 8 a 60 caracteres', Rules.unespacio]"
                            maxlength="60" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="email" label="Email"
                            :rules="[v => /.+@.+\..+/.test(v) || 'El email debe ser válido', Rules.sinespacio]"
                            maxlength="50" prepend-inner-icon="mail" v-lowercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model="password" label="Password"
                            :rules="[v => !!v || 'Password requerido', v => v.length >= 8 || 'El password debe tener mas de 8 caracteres']"
                            maxlength="30" prepend-inner-icon="password"
                            :append-icon="mostrarpassword ? 'visibility' : 'visibility_off'"
                            :type="mostrarpassword ? 'text' : 'password'"
                            @click:append="mostrarpassword = !mostrarpassword" hide-details></v-text-field>
                        </v-col>
                        <!-- Mensaje error usuario -->
                        <v-col cols="12" v-if="mensajeUsuario != ''">
                          <v-alert text dense type="error">{{ mensajeUsuario }}</v-alert>
                        </v-col>
                        <!-- Mensaje error usuario -->
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar usuario -->

              <!-- Modal activar, desactivar usuario -->
              <v-dialog v-model="adModal" max-width="290">
                <v-card>
                  <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Activar Usuario?</v-card-title>
                  <v-card-title class="headline justify-center" v-if="adAccion == 2">¿Desactivar Usuario?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    el Usuario {{ adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn text x-small color="error" @click="activarDesactivarCerrar">Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar">Activar</v-btn>
                    <v-btn v-if="adAccion == 2" text x-small color="warning" @click="desactivar">Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar usuario -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar usuario -->

          <template v-slot:item.fecha_ingreso="{ item }">
            <span>{{ item.fecha_ingreso | formatearFecha }}</span>
          </template>

          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <v-btn text x-small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text x-small color="warning" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
            </template>
          </template>

          <template v-slot:item.accion="{ item }">
            <v-btn x-small icon>
              <v-icon color="info" @click="editItem(item)">edit</v-icon>
            </v-btn>
          </template>
          <!-- Fin Opciones editar, eliminar usuario -->
        </v-data-table>
        <!-- Fin Listado de usuarios y opciones de titulo, busqueda, nuevo, etc -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      usuarios: [],
      dialog: false,
      cabUsuario: [
        //{ text: "CdUs", value: "idusuario", sortable: false },
        { text: "Usuario", value: "nickname", sortable: false },
        { text: "Nombres", value: "nombres", sortable: false },
        //{ text: "DNI", value: "num_documento", sortable: false },
        //{ text: "DIRECCIÓN", value: "direccion", sortable: false },
        //{ text: "TELÉFONO", value: "telefono", sortable: false },
        { text: "Rol", value: "rol", sortable: false },
        { text: "Fec. Ingreso", value: "fecha_ingreso", sortable: false },
        { text: "Condición", value: "condicion", sortable: false },
        { text: "Opc.", value: "accion", sortable: false },
      ],
      cabUsuarioSA: [
        //{ text: "CdUs", value: "idusuario", sortable: false },
        { text: "Empresa", value: "nomempresa", sortable: false },
        { text: "Usuario", value: "nickname", sortable: false },
        { text: "Nombres", value: "nombres", sortable: false },
        //{ text: "DNI", value: "num_documento", sortable: false },
        //{ text: "DIRECCIÓN", value: "direccion", sortable: false },
        //{ text: "TELÉFONO", value: "telefono", sortable: false },
        { text: "Rol", value: "rol", sortable: false },
        { text: "Fec. Ingreso", value: "fecha_ingreso", sortable: false },
        { text: "Condición", value: "condicion", sortable: false },
        { text: "Opc.", value: "accion", sortable: false },
      ],
      buscar: "",
      editedIndex: -1,
      idusuario: "",
      idrol: "",
      roles: [],
      idempresa: "",
      empresas: [],

      nombres: "",
      apellidos: "",
      tipo_documento: "",
      num_documento: "",
      direccion: "",
      telefono: "",
      email: "",
      nickname: "",
      password: "",
      act_password: false,
      passwordAnt: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",

      mensajeUsuario: "",

      desabilitar: false,

      uinactivo: false,

      avatar: "1",
      avatares: [
        {
          value: "1",
          image: "data:image/png;base64,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",
        },
        {
          value: "2",
          image: "data:image/png;base64,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",
        },
        {
          value: "3",
          image: "data:image/png;base64,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",
        },
        {
          value: "4",
          image: "data:image/png;base64,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",
        },
      ],

      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },
      mostrarpassword: false, // Mostrar ocultar contraseña
      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },
  computed: {
    ...mapGetters(["esSuperadministrador", "esAdministrador"]),
    ...mapState(["usuarioState", "empresaState"]),
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Actualizar Usuario";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.selectRol();
    this.selectEmpresa();
    this.idempresa = parseInt(this.usuarioState.idempresa);
  },
  methods: {
    /* Listar usuarios */
    listar() {
      let me = this;
      me.loading = true;

      let url = "";
      if (me.esSuperadministrador) {
        url = "api/Usuarios/ListarUsuarioFiltro?buscar=" + (me.buscar == "" ? "-" : me.buscar) + "&uinactivo=" + me.uinactivo;
      } else {
        url = "api/Usuarios/ListarUsuario/" + me.usuarioState.idempresa + "/" + me.uinactivo;
      }

      axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          me.usuarios = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Listar usuarios */

    /* Seleccionar rol, empresa, etc */
    selectRol() {
      let me = this;

      var rolesArray = [];
      let url = "";
      if (this.esSuperadministrador) {
        url = "api/Roles/SelectSuper";
      } else {
        url = "api/Roles/Select";
      }

      axios
        .get(url)
        .then(function (response) {
          rolesArray = response.data;
          rolesArray.map(function (x) {
            me.roles.push({ text: x.nombre, value: x.idrol });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    selectEmpresa() {
      let me = this;

      var empresasArray = [];
      axios
        .get("api/Empresas/Select")
        .then(function (response) {
          empresasArray = response.data;
          empresasArray.map(function (x) {
            me.empresas.push({ text: x.nombre, value: x.idempresa });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Seleccionar rol, empresa, etc */

    /* Editar y guardar usuario */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (this.editedIndex > -1) {
        // Código para editar usuario
        if (me.password != me.passwordAnt) {
          // Verificamos si el administrador actualizo la contraseña de usuario para enviar el cambio
          me.act_password = true;
        }
        axios
          .put("api/Usuarios/Actualizar", {
            idusuario: me.idusuario,
            idrol: me.idrol,
            idempresa: me.idempresa,
            nombres: me.nombres,
            apellidos: me.apellidos,
            num_documento: me.num_documento,
            direccion: me.direccion,
            telefono: me.telefono,
            email: me.email,
            avatar: me.avatar,
            nickname: me.nickname,
            password: me.password,
            act_password: me.act_password,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeUsuario = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        // Código para guardar nuevo
        axios
          .post("api/Usuarios/Crear", {
            idrol: me.idrol,
            idempresa: me.idempresa,
            nombres: me.nombres,
            apellidos: me.apellidos,
            num_documento: me.num_documento,
            direccion: me.direccion,
            telefono: me.telefono,
            email: me.email,
            avatar: me.avatar,
            nickname: me.nickname,
            password: me.password,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeUsuario = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },
    /* Fin Editar y guardar usuario */

    /* Limpiar mensaje usuario */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeUsuario = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje usuario */

    /* Editar usuario item */
    editItem(item) {
      this.idusuario = item.idusuario;
      this.idrol = item.idrol;
      this.idempresa = item.idempresa;
      this.nombres = item.nombres;
      this.apellidos = item.apellidos;
      this.num_documento = item.num_documento;
      this.direccion = item.direccion;
      this.telefono = item.telefono;
      this.email = item.email;
      this.avatar = item.avatar;
      this.nickname = item.nickname;
      this.password = item.password_hash;
      this.passwordAnt = item.password_hash;
      this.editedIndex = 1;
      this.dialog = true;
    },
    /* Fin Editar usuario item */

    /* Cerrar ventana usuario */
    close() {
      this.dialog = false;
      this.limpiar();
    },
    /* Fin Cerrar ventana usuario */

    /* Limpiar usuario item */
    limpiar() {
      this.idusuario = "";
      this.idrol = "";
      //this.idempresa = "";
      this.idempresa = parseInt(this.usuarioState.idempresa);
      this.nombres = "";
      this.apellidos = "";
      this.num_documento = "";
      this.direccion = "";
      this.telefono = "";
      this.email = "";
      this.avatar = "1";
      this.nickname = "";
      this.password = "";
      this.passwordAnt = "";
      this.act_password = false;
      this.mensajeUsuario = "";
      this.mostrarpassword = false;
      this.editedIndex = -1;
    },
    /* Fin Limpiar usuario item */

    /* Desactivar, activar usuario */
    desactivar() {
      let me = this;

      axios
        .put("api/Usuarios/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombres;
      this.adId = item.idusuario;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      let me = this;

      axios
        .put("api/Usuarios/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar usuario */

    /* Crear PDF usuario */
    crearPDF() {
      var columns = [
        { header: "CdUs", dataKey: "idusuario" },
        { header: "Usuario", dataKey: "nickname" },
        { header: "NOMBRE", dataKey: "nombres" },
        { header: "DNI", dataKey: "num_documento" },
        { header: "DIRECCIÓN", dataKey: "direccion" },
        { header: "TELEFONO", dataKey: "telefono" },
        { header: "EMAIL", dataKey: "email" },
        { header: "C", dataKey: "condicion" },
      ];
      var body = [];

      this.usuarios.map(function (x) {
        body.push({
          idusuario: x.idusuario,
          nickname: x.nickname,
          nombres: x.nombres + " " + x.apellidos,
          num_documento: x.num_documento,
          direccion: x.direccion,
          telefono: x.telefono,
          email: x.email,
          condicion: x.condicion == 1 ? "A" : "I",
        });
      });
      //console.log(body);
      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE USUARIOS", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
          doc.addImage(imgData, "JPEG", 40, 17, 35, 40);
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      // Configurando hoja
      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("p", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          idusuario: { cellWidth: 30 },
          nickname: { cellWidth: 50 },
          nombres: { cellWidth: 100.18 },
          num_documento: { cellWidth: 55 },
          direccion: { cellWidth: 100 },
          telefono: { cellWidth: 70 },
          email: { cellWidth: 80 },
          condicion: { cellWidth: 30, halign: "center" },
        },
      });
      // 515 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Usuarios.pdf");
    },
    /* Fin Crear PDF usuario */
  },
};
</script>
